const state = {
    quickLinks: JSON.parse(localStorage.getItem('quickLinks')) ?? [],
}

const getters = {
    quickLinks: state => state.quickLinks,
}

const actions = {

    async updateQuickLinks({
        commit
    }, quickLinkItem) {
        await commit('setQuickLinks', quickLinkItem);
    },

}

const mutations = {
    setQuickLinks(state, quickLinkItem) {
        // check if item link exists in quicklinks
        var ql = state.quickLinks ? state.quickLinks.find(ql => ql.link == quickLinkItem.link) : null;
        // if yes update count
        if (ql != null) {
            state.quickLinks.splice(state.quickLinks.indexOf(ql), 1);
            state.quickLinks.unshift(ql);
        }
        else {
            // if no, add to quick links
            if(state.quickLinks.length == 10) return;
            state.quickLinks.unshift(quickLinkItem);
        }
		localStorage.setItem('quickLinks', JSON.stringify(state.quickLinks));

    }
}

export default {
    state,
    getters,
    actions,
    mutations
}